import { call, put, select, takeEvery } from "redux-saga/effects"
import {
  GET_CATEGORY,
  GET_CATEGORY_BY_ID,
  GET_CATEGORY_LIST,
} from "./actionTypes"
import {
  getProductCategoryAPI,
  getProductCategoryByIdAPI,
  getProductCategoryListAPI,
} from "helpers/product_category_helper"

import {
  getProductCategorySuccess,
  getProductCategoryError,
  getProductCategoryListSuccess,
  getProductCategoryListError,
  getProductCategoryByIdSuccess,
} from "./actions"
import debounce from "debounce-promise"
import { getCraftsmanSuccess } from "store/actions"

const debouncegetProductCategoryAPI = debounce(getProductCategoryAPI, 1000)
const debouncegetProductCategoryListAPI = debounce(
  getProductCategoryListAPI,
  1000
)

function* fetchProductCategory(args) {
  let params = args.payload
  yield put(getProductCategorySuccess({ status: "process", data: {} }))
  try {
    let { data } = yield call(debouncegetProductCategoryAPI, params)
    yield put(getProductCategorySuccess({ status: "success", data }))
  } catch (error) {
    yield put(getProductCategoryError(error?.response))
  }
}

// get global state
export const getState = ({ Users }) => Users

function* fetchProductCategoryById(args) {
  if (args.id) {
    try {
      let { data } = yield call(getProductCategoryByIdAPI, args.id)

      yield put(getProductCategoryByIdSuccess(data))

      let store = yield select(getState)

      let craftsman = [...store.craftsman]
      craftsman.map(item => {
        let unique = data.craftsmanTypes.find(a => a === item.label)
        if (item.label === unique) {
          item.isChecked = true
        } else {
          item.isChecked = false
        }
      })
      yield put(getCraftsmanSuccess(craftsman))
    } catch (error) {
      console.log(error.response)
    }
  } else {
    yield put(getProductCategoryByIdSuccess(null))
  }
}

function* fetchProductCategoryList() {
  yield put(getProductCategoryListSuccess({ status: "process", data: [] }))
  try {
    let { data } = yield call(debouncegetProductCategoryListAPI)
    yield put(getProductCategoryListSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getProductCategoryListError(error?.response))
  }
}

function* fabricTradingSaga() {
  yield takeEvery(GET_CATEGORY, fetchProductCategory)
  yield takeEvery(GET_CATEGORY_BY_ID, fetchProductCategoryById)
  yield takeEvery(GET_CATEGORY_LIST, fetchProductCategoryList)
}

export default fabricTradingSaga
